import CustomTables, { Column, ILazyParams, } from "../../../../components/CustomTable/CustomTables";
import MyDiv from "./membersintractionList.style"
import { Box, Center, Checkbox, Grid, GridItem, Spinner } from "@chakra-ui/react"

const MembersintractionList = ({ loading, member, selectedEmployees, toggleRow, toggleAll , query, setQuery, totalCount,}: any) => {

    const tableLazyParams: ILazyParams = {
        first: query?.lazyParams?.first ?? 0,
        rows: query?.lazyParams?.rows ?? 20,
        sortField: query?.lazyParams?.sortField || undefined,
        sortOrder: query?.lazyParams?.sortOrder ?? 1,
        filters: query?.lazyParams?.filters ?? {},
        multiSortMeta: [],
        globalFilter: "",
    };

    const handleLazyChange = (params: ILazyParams) => {
        setQuery((prev: any) => {
            const rows = params.rows ?? prev.lazyParams.rows ?? 20;
            const filtersChanged = JSON.stringify(params.filters ?? {}) !== JSON.stringify(prev.lazyParams.filters ?? {});
            const first = filtersChanged ? 0 : (params.first ?? 0);

            return {
                ...prev,
                lazyParams: {
                    ...prev.lazyParams,
                    first,
                    rows,
                    page: Math.floor(first / rows),
                    sortField: params.sortField ?? "",
                    sortOrder: params.sortOrder ?? 1,
                    filters: params.filters ?? {},
                },
            };
        });
    };

    return (
        <MyDiv>
            <Box className="table_wrapper" mt={2}>
                <CustomTables<any>
                    value={member}
                    loading={loading}
                    lazy
                    lazyParams={tableLazyParams}
                    onLazyParamsChange={handleLazyChange}
                    totalRecords={totalCount}
                    showPagination
                    rowsPerPageOptions={[20, 30, 50, 100]}
                    showGlobalSearch={false}
                    showToolbar
                    preferenceKey="membersInteraction"
                    emptyMessage="No Members Found"
                    maxTableHeight={null}
                >
                    <Column
                        header={
                            <Checkbox colorScheme="green" isChecked={
                                    member.length > 0 && member.every((m: any) =>
                                        selectedEmployees.some( (s: any) => s.id === m.id
                                        )
                                    )
                                }
                                isIndeterminate={
                                    member.some((m: any) =>
                                        selectedEmployees.some(
                                            (s: any) => s.id === m.id
                                        )
                                    ) &&
                                    !member.every((m: any) =>
                                        selectedEmployees.some(
                                            (s: any) => s.id === m.id
                                        )
                                    )
                                }
                                onChange={toggleAll}
                            />
                        }
                        body={(row: any) => (
                            <Checkbox colorScheme="green" isChecked={selectedEmployees.some(
                                    (e: any) => e.id === row.id
                                )}
                                onChange={() => toggleRow(row)}
                            />
                        )}
                    />

                    <Column header="S. No" body={(_, index) => query.lazyParams.first + index + 1} />
                    <Column field="name" header="Name" sortable filterable filterType="text"/>
                    <Column field="phone" header="Phone" />
                    <Column field="email" header="Email"/>
                    <Column field="company" header="Company" sortable filterable filterType="text" />
                    <Column field="branch" header="Branch" sortable filterable filterType="text" />
                    <Column field="department" header="Department" sortable filterable filterType="text"/>
                    <Column field="designation" header="Designation" sortable filterable filterType="text" />
                    <Column field="role" header="Role" />
                </CustomTables>
            </Box>
        </MyDiv>
    )
};

export default MembersintractionList;
